import React from "react";
import { PORTFOLIO } from "../data/site";
import { Youtube, Music } from "lucide-react";

export default function Portfolio() {
  const youtubeItems = PORTFOLIO.filter((p) => p.type === "youtube");
  const spotifyItems = PORTFOLIO.filter((p) => p.type === "spotify");

  return (
    <section id="portfolio" data-testid="portfolio-section" className="bg-cream text-ink py-24 md:py-32 px-5 md:px-10 lg:px-16">
      <div className="grid grid-cols-12 gap-6 mb-16 items-end">
        <div className="col-span-12 md:col-span-8">
          <div className="inline-flex items-center gap-2 bg-ink text-cream rounded-full px-4 py-2 mb-6">
            <span className="font-body text-xs tracking-widest uppercase">Portefólio</span>
          </div>
          <h2 className="font-display font-extrabold text-5xl md:text-7xl leading-[0.92]">
            em rotação. <br/><span className="font-hand text-6xl md:text-8xl text-hot">agora mesmo ♪</span>
          </h2>
        </div>
        <div className="col-span-12 md:col-span-4">
          <p className="font-body text-base text-ink/70">
            Uma amostra de alguns projetos feitos por nós...
          </p>
        </div>
      </div>

      {/* YouTube videos */}
      <div className="mb-10">
        <div className="flex items-center gap-3 mb-4">
          <Youtube size={20} className="text-hot" />
          <span className="font-display font-bold text-lg">Videoclips</span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {youtubeItems.map((item, idx) => (
            <div
              key={`yt-${idx}`}
              data-testid={`portfolio-youtube-${idx}`}
              className="bg-white rounded-3xl p-3 border-2 border-ink/10 hover:border-ink transition-colors"
            >
              <iframe
                title={item.title}
                src={`https://www.youtube.com/embed/${item.id}`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full aspect-video bg-ink rounded-2xl"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Spotify tracks as compact list */}
      <div>
        <div className="flex items-center gap-3 mb-4">
          <Music size={20} className="text-hot" />
          <span className="font-display font-bold text-lg">Em destaque no Spotify</span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 bg-white rounded-3xl p-4 md:p-6 border-2 border-ink/10">
          {spotifyItems.map((item, idx) => (
            <iframe
              key={`sp-${idx}`}
              data-testid={`portfolio-spotify-${idx}`}
              title={`Faixa ${idx + 1}`}
              src={`https://open.spotify.com/embed/track/${item.id}?theme=0`}
              allow="encrypted-media"
              loading="lazy"
              className="w-full bg-transparent rounded-xl"
              style={{ height: 80 }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
